import * as yup from 'yup';

const groupFormSchema = yup.object().shape({
  name: yup.string().required('accessGroupsNameRequired'),
});

export default groupFormSchema;
